import React from "react";
import { IconSize, IconProps } from "../theme";

const Document: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.625 13.83C30.4394 13.5727 30.1952 13.3632 29.9127 13.2189C29.6301 13.0746 29.3173 12.9995 29 13H27V11C27 10.4696 26.7893 9.96086 26.4142 9.58579C26.0391 9.21071 25.5304 9 25 9H16.3337L12.8675 6.4C12.5207 6.14148 12.1 6.00125 11.6675 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V26C3 26.2652 3.10536 26.5196 3.29289 26.7071C3.48043 26.8946 3.73478 27 4 27H26.3875C26.5974 27 26.802 26.934 26.9722 26.8113C27.1425 26.6886 27.2699 26.5154 27.3363 26.3162L30.8975 15.6325C30.9976 15.3319 31.0252 15.0118 30.9778 14.6985C30.9304 14.3852 30.8095 14.0876 30.625 13.83ZM11.6675 8L15.1337 10.6C15.4804 10.8587 15.9012 10.9989 16.3337 11H25V13H18.3037C17.9087 13 17.5224 13.117 17.1938 13.3363L14.6938 15H8.6775C8.27742 14.9989 7.88628 15.1182 7.55498 15.3425C7.22369 15.5668 6.96758 15.8856 6.82 16.2575L5 20.8075V8H11.6675Z"
        fill="#071443"
      />
    </svg>
  );
};

export default Document;
